import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import Utils from "@/vue/infrastructure/utils/helpers";
import DfStore from "@/vue/domain/store/df-store";
import { CONTAINER_TYPES } from "@/vue/infrastructure/ioc/container-types";
import ServiceInterface from "@/vue/service/service-interface";
import DfCoupon from "@/vue/domain/df-coupon";
import DfUser from "@/vue/domain/user/df-user";
import Http from "axios";

@Component({
  components: {
    DfHeaderMobile: () => Utils.externalComponent2("df-header-mobile"),
    DfStoreCard: () => Utils.externalComponent2("df-store-card"),
    DfCardCoupon: () => Utils.externalComponent2("df-card-coupon"),
    DfLoadingMask: () => import(/* webpackChunkName: 'df-loading-mask' */ "@/vue/components/df-loading-mask/df-loading-mask.vue"),
  },
})
export default class DfPageAccountCoupon extends Vue {
  @Inject(CONTAINER_TYPES.ServiceInterface)
  private service!: ServiceInterface;
  private busy = false;
  private activeTab: "LoyalGuruCoupon" | "SaviCoupon" = null;
  private saviError = false;
  private cordovaSaviUrl = "";

  get currentStore(): DfStore {
    return this.$store.getters.currentStore;
  }

  get activedCoupon(): number {
    return this.couponList.filter((coupon: DfCoupon) => coupon.selected).length;
  }

  get clubCardNumber(): DfUser {
    return Utils.getPropertyValue(this.currentUser, Utils.PROPERTY_USER_CAMI_CARD_NUMBER, "STRING");
  }

  get currentUser(): DfUser {
    return this.$store.getters.user;
  }

  get checkActionActived(): boolean {
    return this.couponList.findIndex((coupon: DfCoupon) => coupon.checked) > -1;
  }

  get couponList(): Array<DfCoupon> {
    return this.$store.getters.couponList;
  }

  set couponList(couponList: Array<DfCoupon>) {
    this.$store.dispatch("setCouponList", couponList);
  }

  get massiveActivation(): boolean {
    const coupon: DfCoupon = this.couponList.find((coupon: DfCoupon) => coupon.checked);
    return coupon && !coupon.selected;
  }

  get enableLoyalGuruCoupon(): boolean {
    return Utils.enableLoyalGuruCoupon();
  }

  get enableSaviCoupon(): boolean {
    return Utils.enableSaviCoupon();
  }

  get isCordova(): boolean {
    return !!(<any>window).cordova;
  }

  beforeMount() {
    if (this.currentUser) {
      if (this.enableLoyalGuruCoupon && this.couponList.length === 0) {
        this.getCoupons();
      }

      if (this.enableSaviCoupon) {
        console.log("SMT: Savi coupon enabled");
      }

      if (this.enableLoyalGuruCoupon) {
        this.activeTab = "LoyalGuruCoupon";
      } else if (this.enableSaviCoupon) {
        this.activeTab = "SaviCoupon";
      } else {
        this.$router.push({ name: "home-store", params: { storeAlias: this.currentStore.alias } });
      }
    }
  }

  mounted() {
    this.handleSaviCoupon();
  }

  beforeDestroy() {
    document.removeEventListener("getSaviConsumerData", this.getSaviConsumerData);
    document.removeEventListener("getSaviGalleryLoaded", this.getSaviGalleryLoaded);
  }

  private handleSaviCoupon() {
    if (this.enableSaviCoupon && this.clubCardNumber) {
      this.saviError = false;
      if (this.isCordova) {
        this.service
          .getSaviEncrypt(`{"ID": "${this.clubCardNumber}"}`)
          .then((encryptedData: string) => {
            if (encryptedData) {
              const encodedConsumerData = encodeURIComponent(encryptedData);
              const instanceName = "it-Maxidi-AeO-FAM-GAL";
              const synSrc = "T4L%2ByTJgRvc%3D";
              this.cordovaSaviUrl = `${Utils.getSaviCouponScriptUrl()}/instances/${instanceName}?lang=it&synSrc=${synSrc}&consumerData=${encodedConsumerData}`;
              const dominioAutorizzato = "https://promo.smt.cloud/famila-nord/account/coupon";
            } else {
              console.error("Encrypt data non presente");
              this.saviError = true;
            }
          })
          .catch(() => {
            console.error("Errore durante la chiamata encrypt");
            this.saviError = true;
          });
      } else {
        const valassisScriptUtilitiesId = "ValassisScriptUtilities";
        if (!document.getElementById(valassisScriptUtilitiesId)) {
          this.service
            .getSaviEncrypt(`{"ID": "${this.clubCardNumber}"}`)
            .then((encryptedData: string) => {
              const script = document.createElement("script");
              script.id = valassisScriptUtilitiesId;
              script.type = "text/javascript";
              script.text = `
          function getConsumerData(loginRequired, setConsumerData) {
            console.log("SMT: Call getConsumerData internal", loginRequired, setConsumerData);
            setConsumerData("${encryptedData}");
            const event = new CustomEvent("getSaviConsumerData", {
              detail: {
                data: "getConsumerData done",
              },
            });
            document.dispatchEvent(event);
          }
  
          function galleryLoaded() {
            console.log("SMT: Call galleryLoaded: external script");
            const event = new CustomEvent("getSaviGalleryLoaded");
            document.dispatchEvent(event);
          }
          `;
              document.body.appendChild(script);
              console.log("SMT: Utilities Savi iniettato nel body.");

              const valassisGalleryScriptId = "ValassisGalleryScriptId";
              if (!document.getElementById(valassisGalleryScriptId)) {
                const newScript = document.createElement("script");
                newScript.src = Utils.getSaviCouponScriptUrl();
                newScript.id = valassisGalleryScriptId;
                newScript.async = true;
                newScript.onload = () => {
                  if ((<any>window).valassis) {
                    (<any>window).valassis.expand();
                  }
                };
                this.$el.appendChild(newScript);
              }
            })
            .catch(() => {
              this.saviError = true;
            });
        } else {
          console.log("SMT: Utilities Savi già presenti.");
        }
        document.addEventListener("getSaviConsumerData", this.getSaviConsumerData);
        document.addEventListener("getSaviGalleryLoaded", this.getSaviGalleryLoaded);
      }
    }
  }

  private getSaviConsumerData(data: any) {
    console.log("getSaviConsumerData", data.detail);
  }

  private getSaviGalleryLoaded(data: any) {
    console.log("SMT: Call galleryLoaded internal script");
  }

  private checkCoupon(coupon: DfCoupon) {
    coupon.checked = !coupon.checked;
    if (coupon.checked) {
      this.couponList = this.couponList.map((item: DfCoupon) => {
        item.checkDisabled = item.selected !== coupon.selected;
        return item;
      });
    } else if (!this.checkActionActived) {
      this.couponList = this.couponList.map((item: DfCoupon) => {
        item.checkDisabled = false;
        return item;
      });
    }
  }

  private getCoupons() {
    this.busy = true;
    this.service
      .getVoucherAll({
        status: DfCoupon.STATUS_AVAILABLE,
        storeAlias: this.currentStore.alias,
      })
      .then((coupons: Array<DfCoupon>) => {
        this.couponList = coupons;
        this.busy = false;
      })
      .catch((error: Error) => {
        Utils.defaultApiErrorHandler(error, this, () => {
          this.getCoupons();
        });
        this.busy = false;
      });
  }

  private goToStorePage(store: DfStore) {
    this.$router.push({ name: "store", params: { storeAlias: store.alias } }).catch((err) => err);
  }

  private massiveCheckReset() {
    this.couponList = this.couponList.map((coupon: DfCoupon) => {
      coupon.checked = false;
      coupon.checkDisabled = false;
      return coupon;
    });
  }

  private massiveUpdate(coupon: DfCoupon) {
    const action: string = this.massiveActivation ? DfCoupon.ACTION_SELECT : DfCoupon.ACTION_DESELECT;
    const codes: Array<string> = this.couponList.filter((coupon: DfCoupon) => coupon.checked).map((coupon: DfCoupon) => coupon.code);
    this.updateCoupon(action, codes);
  }

  private openMap() {
    window.open(`${Utils.GOOGLE_MAP_URL}${Utils.storeGoogleMapsCoordinates(this.currentStore)}`, "_blank");
  }

  private toggleCoupon(coupon: DfCoupon) {
    const action: string = coupon.selected ? DfCoupon.ACTION_DESELECT : DfCoupon.ACTION_SELECT;
    this.updateCoupon(action, [coupon.code]);
  }

  private updateCoupon(action: string, codes: Array<string>) {
    this.busy = true;
    this.service
      .selectVoucher({
        action: action,
        codes: codes,
      })
      .then(() => {
        this.getCoupons();
      })
      .catch((error: Error) => {
        Utils.defaultApiErrorHandler(error, this, () => {
          this.updateCoupon(action, codes);
        });
        this.busy = false;
      });
  }
}
